import { isString } from 'lodash-es';
const ComparatorResolutionKind = {
  GT: 'GT',
  EQ: 'EQ',
  LT: 'LT',
  NONE: 'NONE'
};
const compare = (v1 = '', v2 = '') => {
  const [v1m = '0', v1v = '0', v1p = '0'] = isString(v1) ? v1.split('.') : [];
  const [v2m = '0', v2v = '0', v2p = '0'] = isString(v2) ? v2.split('.') : [];
  const splitV1 = [v1m, v1v, v1p];
  const splitV2 = [v2m, v2v, v2p];
  return splitV1.reduce((acc, svalue, index) => {
    if (acc === ComparatorResolutionKind.EQ || acc === ComparatorResolutionKind.NONE) {
      const f1 = parseInt(svalue, 10);
      const f2 = parseInt(splitV2[index], 10);
      if (f1 > f2) {
        return ComparatorResolutionKind.GT;
      }
      if (f1 < f2) {
        return ComparatorResolutionKind.LT;
      }
      if (f1 === f2) {
        return ComparatorResolutionKind.EQ;
      }
    }
    return acc;
  }, ComparatorResolutionKind.NONE);
};
export const versionGte = (v1 = '', v2 = '') => {
  const resolution = compare(v1, v2);
  return resolution === ComparatorResolutionKind.GT || resolution === ComparatorResolutionKind.EQ;
};
//# sourceMappingURL=version.js.map